/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_362397cc"]'><div><cube-button @_click="showPickerWithUpdate">use-update-data</cube-button><cube-picker-popup ref="__mpx_ref_picker__" title="数据更新" :list="(dataList)" cancelTxt="取消" :selected-index="(selectedIndex)" confirmTxt="确认"/></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_362397cc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_362397cc"}
  /** script content **/
  require("./update-data-picker.mpx.js?isComponent&outputPath=components%2Fupdate-data-picker362397cc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./update-data-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fupdate-data-picker362397cc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_362397cc"],
    ctorType: "component",
    outputPath: "components/update-data-picker362397cc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker-popup/index.mpx?isComponent&outputPath=components%2Findex57353298%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>